import styled from 'styled-components'

export default styled.main`
  position: relative;
  height: 100%;
  flex-grow: 1;
  overflow: auto;
`



// WEBPACK FOOTER //
// ./src/components/App/TabPanel.js